import styled, {css} from "styled-components";

function bulbTypeColors(
    bulbBg: string,
    bulbHighlight: string,
    bulbHighlightShadow: string,
    lightBg: string,
    lightShadow: string,
    lightShadow2: string = "#ffffff6b"
) {
    return css`
        .bulb-slot {
            .bulb-light {
                background-color: ${lightBg};
                box-shadow:
                    ${lightShadow} 0px 0px 14px 0px,
                    ${lightShadow2} 0px 0px 8px 0px;
            }
            .bulb {
                background-color: ${bulbBg};
                box-shadow:
                    ${bulbHighlight} 0.5px 1px 0px 0px inset,
                    ${bulbHighlightShadow} 1px 1px 1px 1px inset;
            }
        }
    `;
}

// cached functions for bulb strong lights
const greenBulbGreenShadow = css`
    ${bulbTypeColors(
        "rgb(127, 248, 0)", // "rgb(255, 159, 233)",
        "rgba(255, 255, 255, 0.163)",
        "rgba(81, 78, 230, 0.078)",
        "rgb(127, 248, 0)", // "rgb(255, 159, 233)",
        "rgb(255, 255, 255)",
        "rgb(127, 248, 0)" // "rgb(255, 159, 233)"
    )}
    .bulb-slot {
        .bulb {
            svg {
                /* z-index: 2; */
            }
        }
        .bulb-strong-light {
            background-color: rgba(127, 248, 0, 0.729); /* rgba(250, 134, 242, 0.729); */
            box-shadow: rgba(127, 248, 0, 0.729) -1px -1px 6px 6px; /* rgba(250, 134, 242, 0.729); */
        }
    }
`;

const whiteBulbGreenShadow = css`
    ${bulbTypeColors(
        "rgb(255, 255, 255)",
        "rgb(255, 255, 255)",
        "rgb(216, 216, 216)",
        "rgb(127, 248, 0)", // "rgb(255, 159, 233)",
        "rgb(255, 255, 255)",
        "rgb(127, 248, 0)", // "rgb(255, 159, 233)",
    )}
`;

const yellowBulbYellowShadow = css`
    ${bulbTypeColors(
        "rgb(255, 252, 159)",
        "rgba(255, 255, 255, 0.6)",
        "rgba(81, 78, 230, 0.078)",
        "rgb(253, 255, 159)",
        "rgb(255, 255, 255)",
        "rgb(255, 250, 159)"
    )}
    .bulb-slot {
        .bulb {
            svg {
                /* z-index: 2; */
            }
        }
        .bulb-strong-light {
            background-color: rgba(127, 248, 0, 0.729); /* rgba(250, 134, 242, 0.729); */
            box-shadow: rgba(127, 248, 0, 0.729) -1px -1px 6px 6px; /* rgba(250, 134, 242, 0.729); */
        }
    }
`;

const peachBulbGreenShadow = css`
    ${bulbTypeColors(
        "rgb(255, 255, 255)",
        "rgb(255, 255, 255)",
        "rgb(255, 255, 255)",
        "rgb(127, 248, 0)", // "rgb(255, 159, 233)",
        "rgb(255, 255, 255)",
        "rgb(127, 248, 0)" // "rgb(255, 159, 233)"
    )}
    .bulb-slot {
        .bulb-strong-light {
            background-color: rgba(127, 248, 0, 0.729); /* rgba(250, 134, 242, 0.729); */
            box-shadow: rgba(127, 248, 0, 0.729) -1px -1px 6px 6px; /* rgba(250, 134, 242, 0.729); */
        }
    }
`;

const bulbColors8n = bulbTypeColors(
    "hsl(30, 93%, 95%)",
    "hsla(30, 0%, 100%, 0.6)",
    "hsla(30, 75%, 60%, 0.125)",
    "hsl(30, 100%, 76%)",
    "hsl(30, 100%, 76%)"
);
const bulbColors5n = bulbTypeColors(
    "hsl(49, 78%, 86%)",
    "hsla(49, 0%, 100%, 0.6)",
    "hsla(49, 75%, 60%, 0.125)",
    "hsl(50, 93%, 70%)",
    "hsl(49, 78%, 86%)"
)
const bulbColors6n = bulbTypeColors(
    "hsl(30, 88%, 91%)",
    "hsla(30, 0%, 100%, 0.61)",
    "hsla(30, 75%, 60%, 0.125)",
    "hsla(30, 100%, 87%, 0.588)",
    "hsl(30, 88%, 91%)"
)
const bulbColors7n = bulbTypeColors(
    "hsl(30, 78%, 86%)",
    "hsla(30, 0%, 100%, 0.61)",
    "hsla(30, 75%, 60%, 0.125)",
    "hsla(50, 88%, 71%, 0.59)",
    "hsl(50, 88%, 91%)"
);



export const LightsOnWheelDefaultBox = styled.div`
    position: absolute;
    width: calc(100% / sqrt(2) + 0px);
    height: calc(100% / sqrt(2) + 0px);

    .bulb-socket:nth-of-type(8n) {
        ${bulbColors8n};
    }

    .bulb-socket:nth-of-type(5n) {
        ${bulbColors5n};
    }

    .bulb-socket:nth-of-type(6n) {
        ${bulbColors6n};
    }

    .bulb-socket:nth-of-type(7n) {
        ${bulbColors7n};
    }

    /* STRONG LIGHTS */
    &.lights-on-wheel.pink-2n  .bulb-socket:nth-of-type(2n) {
        ${whiteBulbGreenShadow};
    }
    &.lights-on-wheel.pink-2n1  .bulb-socket:nth-of-type(6n) {
        ${greenBulbGreenShadow};
    }


    &.lights-on-wheel.pink-2n1  .bulb-socket:nth-of-type(2n + 1) {
        ${whiteBulbGreenShadow};
    }
    &.lights-on-wheel.pink-2n1  .bulb-socket:nth-of-type(6n + 1) {
        ${greenBulbGreenShadow};
    }


    &.lights-on-wheel.yellow-2n  .bulb-socket:nth-of-type(2n) {
        ${yellowBulbYellowShadow};
    }


    &.lights-on-wheel.yellow-2n1  .bulb-socket:nth-of-type(2n + 1) {
        ${yellowBulbYellowShadow};
    }


    &.lights-on-wheel.peach-2n  .bulb-socket:nth-of-type(2n) {
        ${peachBulbGreenShadow};
    }


    &.lights-on-wheel.peach-2n1  .bulb-socket:nth-of-type(2n + 1) {
        ${peachBulbGreenShadow};
    }

`;
